import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBooks"><Path fillRule="evenodd" clipRule="evenodd" d="M14 6.67175L18.8063 5.29357L22.9409 19.7125L18.1346 21.0907L14 6.67175Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M7 3V21H14V3H7ZM8.5 7H12.5V8.5H8.5V7ZM12.5 15.5H8.5V17H12.5V15.5Z" fill="currentColor"/><Path d="M2 5V21H6V5H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooks;
